<template>
	<div v-if="document.document">
		<shared-app-aside-item :title="$t('business.date.document.deposit')">
			{{ setup.i18nDate.documentHistory('deposit', document.document.createdDate) }}
		</shared-app-aside-item>
		<shared-app-aside-item
			v-if="document.document.viewedDetailDate"
			:title="$t('business.date.document.detailViewed')">
			{{ setup.i18nDate.documentHistory('detailViewed', document.document.viewedDetailDate) }}
		</shared-app-aside-item>
		<shared-app-aside-item
			v-if="document.document.viewedDate"
			:title="$t('business.date.document.viewed')">
			{{ setup.i18nDate.documentHistory('viewed', document.document.viewedDate) }}
		</shared-app-aside-item>
		<shared-app-aside-item
			v-if="document.document.downloadedDate"
			:title="$t('business.date.document.downloaded')">
			{{ setup.i18nDate.documentHistory('downloaded', document.document.downloadedDate) }}
		</shared-app-aside-item>
		<shared-app-aside-item
			v-if="useTimeStamp && setup.documentWithSignature(document)"
			:title="$t('business.date.document.signed')">
			{{ document.document.agencySignatureDate
				? setup.i18nDate.documentHistory('signed', document.document.agencySignatureDate)
				: $t('business.date.timestampInProgress') }}
		</shared-app-aside-item>
		<slot/>
	</div>
</template>

<script setup lang="ts">
// #region Setup
import type { SharedDetailsDocumentHistoryEmits, SharedDetailsDocumentHistoryProps } from './SharedDetailsDocumentHistorySetup';
import SharedDetailsDocumentHistorySetup from './SharedDetailsDocumentHistorySetup';
const emits = defineEmits<SharedDetailsDocumentHistoryEmits>() as SharedDetailsDocumentHistoryEmits;
const props = withDefaults(defineProps<SharedDetailsDocumentHistoryProps>(), SharedDetailsDocumentHistorySetup.defaultProps);
const setup = new SharedDetailsDocumentHistorySetup(props, emits);
// #endregion
</script>
